<template>
  <base-section
    id="map"
    space="0"
  >
    <iframe
      allowfullscreen
      aria-hidden="false"
      frameborder="0"
      height="500"
      :src="src"
      style="border:0; display: block;"
      tabindex="0"
      width="100%"
    />
  </base-section>
</template>

<script>
  export default {
    name: 'SectionMap',

    provide: {
      heading: { align: 'center' },
    },

    computed: {
      src () {
        return 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3171.4148561058523!2d-6.14286034862575!3d37.356359543794596!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1213cddd247731%3A0xeaddcc49bd99f194!2sP.%C2%BA%20de%20Bollullos%20de%20la%20Mitaci%C3%B3n%2C%201%2C%2041110%20Bollullos%20de%20la%20Mitaci%C3%B3n%2C%20Sevilla!5e0!3m2!1ses!2ses!4v1647710975853!5m2!1ses!2ses'
      },
      // https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d712892.3408054698!2d-6.376003214216355!3d37.36084072606171!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1213d3bead4385%3A0x9fe97e0b9352d407!2sRosmar%2C%20S.L.!5e0!3m2!1ses!2ses!4v1591984627251!5m2!1ses!2ses
    },
  }
</script>
